"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var _ = require("lodash");
var Barcodes;
(function (Barcodes) {
    function parseBarcode(barcode) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("ParseBarcode");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                Barcode: barcode
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Barcodes.parseBarcode = parseBarcode;
})(Barcodes = exports.Barcodes || (exports.Barcodes = {}));
